<template>
  <div>
    <b-row>
      <b-col cols="9"> </b-col>
      <b-col>
        <base-event-timer :timer.sync="eventTimer"></base-event-timer>
        <div class="lastRefreshTime">{{ lastRefreshTime }}</div>
      </b-col>
    </b-row>
    <div id="bi-main" v-html="biView.embendedCode"></div>
  </div>
  <!-- {{ id }} -->
  <!-- {{ biView }} -->
</template>

<script>
export default {
  name: "PowerBIViewDisplay",
  props: {
    id: String,
  },
  components: {
    BaseEventTimer: () => import("@/components_rms/base/BaseEventTimer.vue"),
  },
  data() {
    return {
      biView: {},
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 0,
        eventTimerSeconds: 0,
        pageUrl: "",
      },
      timer: null,
      refreshTime: 0,
      timer: null,
      lastRefreshTime: "",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {
    if (this.id) {
      this.loadData();
    } else {
      this.loadFirst();
    }
    this.formatDate();
  },

  methods: {
    init() {
      this.refreshData();
      this.formatDate();
    },
    refreshPage() {
      this.timer = setInterval(
        this.init,
        this.eventTimer.eventTimerMiliseconds
      );
    },
    formatDate() {
      let date = new Date();
      // console.log(date);
      let dia = date.getDate();
      let mes = date.getMonth() + 1;
      let ano = date.getFullYear();
      let hour = date.toLocaleTimeString();
      // console.log("Data")
      // console.log(`dia ${dia} mes ${mes} ano ${ano}`)
      if (mes < 10) mes = "0" + mes;

      this.lastRefreshTime = `Última atualização: ${dia}/${mes}/${ano} ${hour}`;
    },
    refreshData() {
      let url2 = document.getElementById("bi-main").children[0].src;
      document.getElementById("bi-main").children[0].src = url2;
    },
    loadData() {
      this.$apiScheduler
        .get("/powerbiview/getView/" + this.id.toString())
        .then((response) => {
          this.biView = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
          }
        });
    },
    loadFirst() {
      this.$apiScheduler
        .get("/powerbiview/getCurrentUserViews/")
        .then((response) => {
          if (response.data.length > 0) {
            this.biView = response.data[0];
            this.$router.push("/bi/" + this.biView.id);
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
          }
        });
    },
  },
  watch: {
    id() {
      this.loadData();
    },
    eventTimer() {
      clearInterval(this.timer);
      this.refreshPage();
    },
  },
};
</script>

<style scoped>
/* #teste1 {
    height: 840px;
} */
#bi-main {
  height: calc(100vh - 160px);
}
.rigth {
  text-align: right;
  margin-left: 85%;
}
.lastRefreshTime {
  font-size: 12px;
}
</style>
